// A cell's metadata.readOnlyFormula (CellMetadata.ReadOnlyFormula): read-only when truthy.
// Evaluated as the controls evaluate showIfFormula - a direct eval with `item` and `rootEntity` in
// scope - and with `this` the calling control, so call it as
// evaluateReadOnlyFormula.call(this, formula, item, rootEntity). A formula that throws counts as
// not read-only, as a showIfFormula that throws counts as shown.
// Shared by client/src/components/varcontrol and inlinevarlist; tested by
// client/tests/readOnlyFormula.test.mjs.
export function evaluateReadOnlyFormula(formula, item, rootEntity) {
  if (!formula) return false

  try {
    return !!eval(formula)
  } catch (e) {
    console.error('ERROR: evaluate readOnlyFormula: ' + e.message)
    return false
  }
}
